import isCharacteristicSkill from '../helpers/isCharacteristicSkill'
import calcSkillValues from '../helpers/calcSkillValues'
//-----------------------------
// process calc skills harness
//-----------------------------
export default function processCalcSkillsHarness({ pfx, character, max_skill }) {
  //-------------------------------------------
  // filter skills for impacted characteristic
  //-------------------------------------------
  const char_skills = character.skills.filter((s) => isCharacteristicSkill(s, pfx) == true)
  //---------------------------
  // loop skills matching char
  //---------------------------
  if (char_skills.length > 0) {
    char_skills.forEach((s) => {
      //-----------------------
      // calc individual skill
      //-----------------------
      calcSkillValues({ skill: s, character: character, max_skill: max_skill })
    })
  }
  return character
}
